import LanguageDTO from './languageDTO';

export default class Control_TranslationDTO {
  controlId: number;

  languageId: number;

  name: string;

  description?: string;

  background?: string;

  implementation?: string;

  outOfScopeReason?: string;

  lang?: LanguageDTO;

  constructor() {
    this.controlId = 0;
    this.languageId = 0;
    this.name = '';
  }
}
